import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { MouseMovementHelperService } from '../../services/mouse-movement-helper.service';
import { ActivityDropZoneHelperService } from '../activity-drop-zone/activity-drop-zone-helper.service';

@Component({
  selector: 'wilson-activity-gap-fill-animation',
  imports: [CommonModule],
  template: `
    @if (
      {
        userId: activityDropZoneHelperService.userId$ | async,
        animationOffsetX: mouseMovementHelperService.animationOffsetX$ | async,
      };
      as data
    ) {
      @if (data.animationOffsetX) {
        <div class="animation-zone">
          <div
            class="firework"
            [class.d-none]="data.userId !== userId"
            [style.left.px]="data.animationOffsetX"
          ></div>
        </div>
      }
    }
  `,
  styleUrls: ['./activity-gap-fill-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityGapFillAnimationComponent {
  readonly mouseMovementHelperService = inject(MouseMovementHelperService);
  readonly activityDropZoneHelperService = inject(
    ActivityDropZoneHelperService,
  );

  @Input() userId: string | undefined;
}
